import styled from "@emotion/styled";
import React, { useCallback } from "react";
import { fontP1Regular } from "src/design-system/styles/fonts";
import { css } from "@emotion/react";
import { compassColors } from "src/utils/styling";
import { breakpointDesktopOnly } from "src/design-system/styles/breakpoints";
import i18n from "@i18n";
import { CheckboxOptions } from "@components/survey/questions/checkboxQuestion";
import Controls from "@components/refactored-survey/Controls";
import { useCheckboxSurvey } from "src/hooks/survey/checkbox-survey";
import { usePageSet } from "src/hooks/pageSet";
import { getSurveyOptionsWithTranslationKeys } from "@pageDefinitions/actions/survey/util";

const Title = styled.div`
  ${fontP1Regular}
`;

const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  padding: 16px 24px;
  flex-direction: column;
  align-items: center;
  @media ${breakpointDesktopOnly} {
    padding: 48px;
  }
`;

const Body = styled.div`
  width: 100%;
  max-width: 400px;
`;

export const labelStyles = css`
  background-color: ${compassColors.white};
  font-weight: 500;
`;

const questionId = "ldsHopingToAchieve";

const options = getSurveyOptionsWithTranslationKeys(
  questionId,
  ["loseWeight", "maintainWeight", "curbHabitsOrCravings", "improveLongevity"],
  { namespace: "introClinical" }
);

export function LDSHopingToAchieve() {
  const { gotoNextPage } = usePageSet();
  const { checkedItems, handleItemChange, sendAnswers, canProceed } =
    useCheckboxSurvey(questionId);

  const onClickNext = useCallback(() => {
    sendAnswers();
    gotoNextPage();
  }, [sendAnswers, gotoNextPage]);

  return (
    <Container>
      <Body>
        <Title>{i18n.t("introClinical:ldsHopingToAchieve:title")}</Title>
        <div data-cy-question={questionId} data-cy="question">
          <CheckboxOptions
            checkedItems={checkedItems}
            options={options}
            onChange={handleItemChange}
            useRedesign
            labelCss={labelStyles}
          />
        </div>
        <Controls
          onClickNext={onClickNext}
          canProceed={canProceed}
          buttonDesignStyle="redesignPrimary"
          next={{
            text: i18n.t("introClinical:ldsHopingToAchieve:cta"),
          }}
          width="min(calc(100% - 2 * 24px), 400px)"
        />
      </Body>
    </Container>
  );
}
